import { render, staticRenderFns } from "./CrmLeadDetailDrawerWrappable.vue?vue&type=template&id=b00a1954&lang=pug&"
import script from "./CrmLeadDetailDrawerWrappable.vue?vue&type=script&lang=js&"
export * from "./CrmLeadDetailDrawerWrappable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports